import { colors } from "@dotnet/telematics-design-system";

import CompanyHeader from "./CompanyHeader";
import CompanyHierarchy from "./CompanyHierarchy";
import CompanyLinks from "./CompanyLinks";

const CompanyDetails = () => {
    const { gray900 } = colors;

    const titleCSS = {
        color: gray900,
        fontWeight: 700,
        fontSize: "14px",
        lineHeight: "20px",
        letterSpacing: "0.1px"
    };

    return (
        <>
            <CompanyHeader />
            <CompanyLinks titleCSS={titleCSS} />
            <CompanyHierarchy titleCSS={titleCSS} />
        </>
    );
};

export default CompanyDetails;
